module.exports = __webpack_public_path__ + "img/home_innovation-image2.8c6eb158.jpg";